import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Header } from "@perxis-auto/ui-kit/lib/components/Header";
import clsx from "clsx";
import { Skeleton } from "./skeleton/Skeleton.js";
import styles from "./ComparisonHeader.module.scss.js";
const ComparisonHeader = memo(function ComparisonHeader2({
  t,
  total,
  isLoading,
  onBackClick,
  onClearClick,
  className,
  ...props
}) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(Skeleton, {});
  }
  return /* @__PURE__ */ jsx(Header, { border: false, className: clsx(styles.comparisonHeader, className), ...props, children: /* @__PURE__ */ jsxs(Row, { align: "middle", gutter: [0, "vertical-sky"], children: [
    /* @__PURE__ */ jsx(Col, { xs: { span: 12, order: 1 }, sm: { span: 12, order: 1 }, md: { span: 6, order: 1 }, children: /* @__PURE__ */ jsx(Row, { align: "middle", justify: "start", children: /* @__PURE__ */ jsx(Col, { flex: "auto", children: /* @__PURE__ */ jsx(Header.Link, { icon: "back", iconPosition: "left", onClick: onBackClick, children: t("widgets.comparisonHeader.backLabel") }) }) }) }),
    /* @__PURE__ */ jsx(Col, { xs: { span: 24, order: 3 }, sm: { span: 24, order: 3 }, md: { span: 12, order: 2 }, children: /* @__PURE__ */ jsx(Header.Heading, { title: t("widgets.comparisonHeader.title"), badge: { count: total, type: "ghost" } }) }),
    /* @__PURE__ */ jsx(Col, { xs: { span: 12, order: 2 }, sm: { span: 12, order: 2 }, md: { span: 6, order: 3 }, children: /* @__PURE__ */ jsx(Row, { align: "middle", justify: "end", children: /* @__PURE__ */ jsx(Col, { hidden: !total, children: /* @__PURE__ */ jsx(Header.Link, { icon: "trash", iconPosition: "right", onClick: onClearClick, children: t("widgets.comparisonHeader.clearLabel") }) }) }) })
  ] }) });
});
export {
  ComparisonHeader
};
